import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  classesPath,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  fetchTeachers,
  fetchClass,
  IClassParam,
  updateClass,
  deleteClass,
  UPDATE_CLASS_SUCCESS_MESSAGE,
  DELETE_CLASS_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import Toast from "../../../molecules/Toast";
import ClassForm from "../../../templates/manager/ClassForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useDidMountEffect from "../../../hooks/useDidMountEffect";

export default (props: { match: { params: { id: string } } }) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();

  const id = parseInt(props.match.params.id, 10);
  React.useEffect(() => {
    if (
      state.success_message === UPDATE_CLASS_SUCCESS_MESSAGE ||
      state.success_message === DELETE_CLASS_SUCCESS_MESSAGE
    ) {
      Toast.success(state.success_message);
      dispatch(clearSuccessMessage());
      history.push(classesPath);
    }
  }, [history, dispatch, state.success_message]);

  useDidMountEffect(() => {
    if (state.error) {
      Toast.error(state.error);
    }
    return () => dispatch(clearErrorMessage());
  }, [dispatch, state.error]);

  const updateClassFunc = React.useCallback(
    (cls: IClassParam) => {
      dispatch(peep(updateClass(cls)));
    },
    [dispatch, peep],
  );

  const deleteClassFunc = React.useCallback(
    (id: number) => {
      dispatch(peep(deleteClass(id)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchTeachers());
    dispatch(fetchClass(id));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, id]);

  const cls = state.classes.filter(cl => cl.id === id)[0];

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.classes, to: classesPath }]}
        currentTitle={titles.editClass}
      />
      <ClassForm
        title={titles.editClass}
        calling={calling}
        cls={cls}
        teacher_ids={state.teachers
          .filter(t => t.class_ids.indexOf(id) !== -1)
          .map(t => t.id)}
        teachers={state.teachers}
        error={state.error}
        isNextYear={false}
        upsertClass={updateClassFunc}
        deleteClass={deleteClassFunc}
      />
    </div>
  );
};
